class TipoEmissaoTransportadora {
  constructor() {
    this.CONTRA_CTE = 1;
    this.EMISSAO_CTE = 2;
    this.TRANSPORTADORA_EXTERNA = 3;
  }

  getTiposLabel() {
    return [
      { label: 'ContraCTe', value: this.CONTRA_CTE },
      { label: 'EmissaoCTE', value: this.EMISSAO_CTE },
      { label: 'Transportadora Externa', value: this.TRANSPORTADORA_EXTERNA },
    ];
  }

  getTipo(tipo) {
    return this.getTiposLabel()
      .filter(label => label.value === tipo)
      .shift();
  }
}

export default new TipoEmissaoTransportadora();
